import styled from "styled-components";
import { Breakpoint } from "@arcteryx/components-typography";

const FsRichText = styled.div`
  p {
    margin-bottom: 0.25rem;
  }
  img {
    width: 100% !important;
    height: auto !important;
  }
  tr {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  td {
    width: 50% !important;
    text-align: center;
    margin-top: 1rem;
    ${Breakpoint("sm")`
      margin-top: 0;
      width: 25% !important;
    `}
    span {
      line-height: 0.65rem !important;
      font-size: 0.65rem !important;
    }
  }
`;

export default FsRichText;
